// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles/LEAsociarPedCtnModal.css */
.contenedor-flex-lemodal {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
}

/* Ajuste del padding en celdas del TreeTable */
.p-treetable .p-treetable-tbody > tr > td,
.p-treetable .p-treetable-thead > tr > th {
  padding: 0.25rem 0.5rem;  /* Reducir espacio vertical y horizontal */
  line-height: 1.2;
  font-size: 0.85rem;
}

/* Opcional: compactar el texto más */
.p-treetable .p-column-title {
  font-size: 0.85rem;
  padding: 0;
  margin: 0;
}

/* Compacta el checkbox lateral */
.p-treetable-toggler {
  padding: 0 !important;
  margin: 0 !important;
}

`, "",{"version":3,"sources":["webpack://./src/styles/LEAsociarPedCtnModal.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;;EAEE,uBAAuB,GAAG,0CAA0C;EACpE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,oBAAoB;AACtB","sourcesContent":["/* styles/LEAsociarPedCtnModal.css */\n.contenedor-flex-lemodal {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n/* Ajuste del padding en celdas del TreeTable */\n.p-treetable .p-treetable-tbody > tr > td,\n.p-treetable .p-treetable-thead > tr > th {\n  padding: 0.25rem 0.5rem;  /* Reducir espacio vertical y horizontal */\n  line-height: 1.2;\n  font-size: 0.85rem;\n}\n\n/* Opcional: compactar el texto más */\n.p-treetable .p-column-title {\n  font-size: 0.85rem;\n  padding: 0;\n  margin: 0;\n}\n\n/* Compacta el checkbox lateral */\n.p-treetable-toggler {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
